import styles from "./index.css?inline";

export const PM_REACT_SEARCH_STYLES = styles;
